import type { ActivityHubViewProps } from "@/lib/activities/registry";
import { ViewDeepThoughtsView } from "./view-deep-thoughts-view";

export function DeepThoughtsHubView({ entityId }: ActivityHubViewProps) {
  return <ViewDeepThoughtsView entityId={entityId} />;
}
